module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "book"
  }, [_c('div', {
    staticClass: "coverInfo"
  }, [_c('img', {
    staticClass: "coverImage",
    attrs: {
      "src": "//textcafe.co/books/AJukYr/tc-custom/9781423616610.jpg?1728353457357",
      "alt": "This image is the cover for the book Alluring Lettuces"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "bookInfo"
  }, [_c('h1', {
    staticClass: "bookTitle heading font1"
  }, [_vm._v("Alluring Lettuces\n    ")]), _vm._v(" "), _c('p', {
    staticClass: "bookDescription body article font2"
  }), _c('p', [_c('b', [_vm._v("A richly illustrated guide to unique and gorgeous vegetable varieties for your garden.")]), _c('br'), _c('br'), _vm._v(" Seventy-five unusual and eminently beautiful vegetables are profiled in this charming book by expert gardener and garden designer Jack Staub. Within these pages, you’ll discover produce not likely found at the supermarket, including the Asparagus Bean, Chinese Rat Tail Radish, Green Zebra Tomato, and Turkish Orange Eggplant. Staub includes history, stories, and lore surrounding the plants, as well as instructions for growing them outdoors or indoors in containers. Whether you're an avid gardener or a dabbler, you'll love the flowery descriptions and original art showcasing these vegetables that are perfect for your garden.")]), _vm._v(" "), _c('p')]), _vm._v(" "), _c('div', {
    staticClass: "authorInfo"
  }, [_c('h2', {
    staticClass: "authorName heading font1"
  }, [_vm._v("\n      Jack Staub, Ellen Buchert\n    ")])]), _vm._v(" "), _c('div', {
    staticClass: "publisherInfo"
  }, [_c('h2', {
    staticClass: "publisherName heading font1"
  }, [_vm._v("\n    Gibbs Smith\n   ")])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-4b7db194","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/home.vue
// module id = 51
// module chunks = 0